import React, { useEffect, useState } from "react";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import Formulario from "../Generales/Formulario";
import { ambienteAplicacion, urlCiudadesAP, urlConsultarDuplicidad, urlConsultarIdentificacion, urlCreaFacturacionAP, urlModificarCarrito, urlProcesoApAbierto, urlRecuperarCarritoAccP, urlSucursales, urlViewFacturacionAP } from "../../constants/urls";
import { useSelector } from "react-redux";
import { apiPost2 } from "../../api";
import { empresa } from "../../constants";
import { useToasts } from 'react-toast-notifications';
import ContainerApFacturacion from "./ContainerApFacturacion";
import { useLocation, useHistory } from 'react-router-dom';

const ComponentApFacturacionSlip = (props) => {

    const location = useLocation();
    const history = useHistory();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');
    const [loading, setLoading] = useState(false)
    const [values, setValues] = useState({})
    const [existeCarrito, setExisteCarrito] = useState(false)
    const [duplicada, setDuplicada] = useState(false)
    const [ciudadesAux, setCiudadesAux] = useState([])
    const { addToast } = useToasts();
    const datosAsesor = useSelector((state) => state.datosUsuarios.dataUsuario);
    const listadoSucursales = useSelector((state) => state.datosSucursales.DataSucursales || []);

    useEffect(() => {
        console.log('cotizador', props)
        window.scrollTo(0, 0);
    }, [])

    const resolverSucursal = async (sucursal) => {
        if (!sucursal) return ""

        const codigo = typeof sucursal === 'object' ? sucursal.value : sucursal

        let sucursales = listadoSucursales
        if (!sucursales.length) {
            try {
                const response = await fetch(urlSucursales)
                const json = await response.json()
                sucursales = json.transaccion ? json.sucursales : []
            } catch (error) {
                sucursales = []
            }
        }

        const encontrada = sucursales.find(s => String(s.sucCodigoCore) === String(codigo))
        if (encontrada) {
            return { value: encontrada.sucCodigoCore, label: encontrada.sucNombre }
        }
        if (datosAsesor && String(datosAsesor.sucursalCodCore) === String(codigo)) {
            return { value: datosAsesor.sucursalCodCore, label: datosAsesor.sucursal }
        }
        if (typeof sucursal === 'object' && sucursal.label && String(sucursal.label) !== String(codigo)) return sucursal
        return { value: codigo, label: codigo }
    }

    /**
     * recupera la información del Facturacion
     */
    const recuperarPoliza = async () => {
        window.scrollTo(0, 0);
        setLoading(true);

        const body = { id: id };
        console.log("🚀 ~ recuperarPoliza ~ body:", body);

        try {
            const response = await fetch(urlViewFacturacionAP, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });

            const json = await response.json();

            if (json.transaccion) {
                const data = json.facturacion;

                const producto = data.carProductos && data.carProductos[0] ? data.carProductos[0] : {};
                const ubicacion = data.datosUbicacion || {};
                const persona = data.datosContratantePersona || {};
                const empresa = data.datosContratanteEmpresa || {};

                const facturacion = {
                    ruc: empresa.cliIdentificacion || "",
                    nombreEmpresa: empresa.cliRazonSocial || "",
                    actividadEmpresa: producto.actividad || "",
                    // cedulaSolicitante: persona.cliIdentificacion || "",
                    // nombreSolicitante: persona.nombreCompleto || "",
                    provincia: ubicacion.provincia || "",
                    ciudad: ubicacion.ciudad || "",
                    direccion: ubicacion.direccion || "",
                    sucursal: await resolverSucursal(ubicacion.sucursal),
                    facturacion: producto.tipo_pago || {},
                    isBlanket: producto.blanket ? "SI" : "NO",
                    vigenciaInicio: producto.fecha_v_inicio || "",
                    vigenciaFin: producto.fecha_v_fin || "",
                    ramo: producto.ramo || "",
                    subramo: producto.subRamo || "",
                    formaPago: producto.formaPago || "",
                };
                console.log("🚀 ~ recuperarPoliza ~ facturacion:", facturacion)

                setExisteCarrito(true);
                setValues(facturacion);
            }

            setLoading(false);
        } catch (error) {
            addToast('Error, recuperar Planes', { appearance: 'error' });
            setLoading(false);
        }
    };

    const guardarInformacion = async (values) => {
        window.scrollTo(0, 0);

        setLoading(true);
        let url = `${urlCreaFacturacionAP}`;
        //let url = `${urlModificarCarrito}`
        const body = {
            "pasoCarrito": "inicio",
            "empresa": "AIGMETROPOLITANA",
            "plataforma": "WEB",
            "ambiente": "Desarrollo",

            "empresaNombre": values.nombreEmpresa ? values.nombreEmpresa.trim() : "",
            "empresaRuc": values.ruc ? values.ruc.trim() : "",

            // "solicitanteNombre": values.nombreSolicitante ? values.nombreSolicitante.trim() : "",
            // "solicitanteCedula": values.cedulaSolicitante ? values.cedulaSolicitante.trim() : "",

            "objetoAsesor": {
                "nombre": `${datosAsesor.nombres} ${datosAsesor.apellidos}`,
                "codigoCore": datosAsesor.cliCodigoCore,
                "sucursalSeleccionada": datosAsesor.sucursalCodCore ? datosAsesor.sucursalCodCore : '',
                "sucursalSeleccionadaNombre": datosAsesor.sucursal ? datosAsesor.sucursal : '',
                "ambiente": ambienteAplicacion,
                "emailAsesor": datosAsesor.correo ? datosAsesor.correo : '',
                "brokerRUC": datosAsesor.brokerRUC ? datosAsesor.brokerRUC : '',
                "brokerNombre": datosAsesor.brokerNombre ? datosAsesor.brokerNombre : '',
                "brokerCodigo": datosAsesor.brokerCodigo ? datosAsesor.brokerCodigo : ''
            },

            "idAsesor": datosAsesor.cliCodigoCore,

            "provincia": values.provincia,
            "ciudad": values.ciudad,

            "direccion": values.direccion ? values.direccion.trim() : "",
            "sucursal": values.sucursal,
            "actividad": values.actividadEmpresa,

            "tipo_pago": values.facturacion,
            "fecha_v_inicio": values.vigenciaInicio,
            "fecha_v_fin": values.vigenciaFin,
            "blanket": values.isBlanket === "SI",

            "codigo": props.datosCotizador && props.datosCotizador.descripcionSeguro
                ? props.datosCotizador.descripcionSeguro
                : "",

            "idCarrito": existeCarrito ? id : "",
            "ramo": values.ramo,
            "subRamo": values.subramo,
            "formaPago": values.formaPago
        };
        try {
            const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' })
            const json = await response.json()
            if (json.transaccion) {
                props.history.push({
                    pathname: props.datosCotizador.urlSiguiente,
                    search: `?id=${json.idCarrito}`,
                });
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }



    const consultarRuc = async (ruc, values, tipo, campoModifica, campoBuscador) => {

        setLoading(true)
        const resultado = await apiPost2(urlConsultarIdentificacion, {
            "empresa": empresa,
            "identificador": ruc,
            "tipo": tipo
        })
        if (resultado.transaccion) {
            let objeto = { ...values }
            objeto[campoModifica] = resultado.datosIdentificador[0][campoBuscador];
            setValues(objeto)
        }
        setLoading(false)
    }

    const consultarProvincia = async (provincia) => {

        setLoading(true)


        const resultado = await apiPost2(urlCiudadesAP, {
            empresa: "AIGMETROPOLITANA",
            codProvincia: provincia,
            ramo: "travel"
        })


        if (resultado.transaccion) {
            setCiudadesAux(resultado.ciudades)
        }



        setLoading(false)
    }

    return (
        <ContainerApFacturacion
            paso={'slip'}
            titulo={props.datosCotizador.titulo}
        >

            <main class="cr-app bg-light">
                <div class="cr-content container-fluid">
                    <div className="container-body-spaces">

                        <LoadingScreen
                            loading={
                                loading
                            }
                            bgColor="#f1f1f1"
                            spinnerColor="#001871"
                            textColor="#676767"
                            logoSrc={logo}
                            text="Obteniendo datos..."
                        >

                            <Formulario
                                codigoFormulario={props.datosCotizador.codigoFormulario}
                                setLoading={(value) => setLoading(value)}
                                onSubmit={async (values, tieneErrores, errores) => {
                                    console.log("🚀 ~ onSubmit={ ~ values:", values)
                                    console.log("🚀 ~ onSubmit={ ~ tieneErrores:", tieneErrores)
                                    if (!tieneErrores) {
                                        setLoading(true);
                                        try {
                                            const checkDuplicidadObj = {
                                                empresa: "AIGMETROPOLITANA",
                                                plataforma: 'WEB',
                                                identificacion: values.ruc,
                                                ramo: (values.ramo && values.ramo.value) ? values.ramo.value : (values.ramo || "")
                                            };

                                            if (existeCarrito) {
                                                await guardarInformacion(values)
                                            } else {
                                                const url = urlConsultarDuplicidad
                                                const response = await fetch(url, { body: JSON.stringify(checkDuplicidadObj), method: 'POST' })
                                                const json = await response.json()
                                                if (json.tienePolizaVigente) {
                                                    setDuplicada(true)
                                                    setLoading(false)
                                                } else {
                                                    setDuplicada(false)
                                                    await guardarInformacion(values)
                                                }
                                            }
                                        } catch (e) {
                                            setLoading(false)
                                        }
                                    }
                                }}
                                values={values}
                                nuevoCarrito={id ? false : true}
                                onChange={(key, values) => {
                                    let filteredValues = {
                                        ...values,
                                        ruc: values.ruc ? values.ruc.replace(/[^0-9]/g, '') : '',
                                        cedulaSolicitante: values.cedulaSolicitante ? values.cedulaSolicitante.replace(/[^0-9]/g, '') : ''
                                    };

                                    var tipoFacturacion =
                                        (filteredValues.facturacion &&
                                            filteredValues.facturacion.label &&
                                            filteredValues.facturacion.label.toLowerCase()) || "";

                                    var vigenciaInicio = filteredValues.vigenciaInicio;

                                    if ((key === 'facturacion' || key === 'vigenciaInicio') && tipoFacturacion && vigenciaInicio) {
                                        var inicioDate = new Date(vigenciaInicio);
                                        var finDate = null;

                                        finDate = new Date(inicioDate);
                                        finDate.setFullYear(finDate.getFullYear() + 1);

                                        if (finDate && !isNaN(finDate)) {
                                            filteredValues.vigenciaFin = finDate.toISOString().split('T')[0];
                                        }
                                    }

                                    setValues(filteredValues);

                                    if (key === 'provincia') {
                                        consultarProvincia(values.provincia.value);
                                    }

                                    if (key === 'ruc') {
                                        if (filteredValues.ruc && filteredValues.ruc.length === 13) {
                                            consultarRuc(filteredValues.ruc, filteredValues, 'ruc', 'nombreEmpresa', 'nombre');
                                        }
                                    }

                                    if (key === 'cedulaSolicitante') {
                                        if (filteredValues.cedulaSolicitante && filteredValues.cedulaSolicitante.length === 10) {
                                            consultarRuc(filteredValues.cedulaSolicitante, filteredValues, 'cedula', 'nombreSolicitante', 'nombre');
                                        }
                                    }
                                }}
                                setValuesInicial={(values) => {
                                    recuperarPoliza(values)
                                }}
                            />
                        </LoadingScreen>



                    </div>
                </div>
            </main>

        </ContainerApFacturacion>

    );
};

export default ComponentApFacturacionSlip;
